// Registers the service worker early so the app is installable and works
// offline. The notification logic in views/app also calls register('/sw.js'),
// which is idempotent — it resolves to this same registration.

export default function registerServiceWorker(): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');

      // When a new SW is found and finishes installing while an old one still
      // controls the page, ask it to activate immediately.
      registration.addEventListener('updatefound', () => {
        const { installing } = registration;
        if (!installing) return;
        installing.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });

      // Reload once the new SW takes control so the user gets fresh assets.
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Service worker registration failed:', err);
    }
  });
}
